module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "articles-report"
  }, [(!_vm.canSeeReport()) ? _c('div', {
    staticClass: "foo"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_articles_report_not_permit')))])]) : _c('div', {
    staticClass: "foo"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_articles_report')))]), _vm._v(" "), _c('section', {
    staticClass: "articles-report__filters section-top-xs"
  }, [_c('div', {
    class: _vm.isMobile() ? 'articles-report__search-grid--mobile' : 'articles-report__search-grid'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search')
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalCode),
      expression: "internalCode"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search_internal_code')
    },
    domProps: {
      "value": (_vm.internalCode)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.internalCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "new-button articles-report__search-btn",
    on: {
      "click": _vm.clickSearch
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(_vm._s(_vm.locale.t('label_do_search')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu scrollmenu-spaced section-top-xs"
  }, _vm._l((_vm.statuses), function(item) {
    return _c('span', {
      key: item.id
    }, [_c('span', {
      staticClass: "chips-group clickable",
      on: {
        "click": function($event) {
          _vm.selectedStatus = item
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item.name))])])]), _vm._v(" \n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "flex-container section-top-xs articles-report__toggles"
  }, [_c('p', {
    staticClass: "toggle-btn-right",
    on: {
      "click": function($event) {
        _vm.showFilters = !_vm.showFilters
      }
    }
  }, [_vm._v("\n          " + _vm._s(!_vm.showFilters ? _vm.locale.t('label_show_filters') : _vm.locale.t('label_clear_filters')) + "\n          "), _c('i', {
    class: _vm.showFilters ? 'ti-arrow-circle-up' : 'ti-arrow-circle-down'
  })]), _vm._v(" "), _c('p', {
    staticClass: "toggle-btn-left",
    on: {
      "click": function($event) {
        _vm.showSort = !_vm.showSort
      }
    }
  }, [_vm._v("\n          " + _vm._s(!_vm.showSort ? _vm.locale.t('label_show_sort') : _vm.locale.t('label_clear_sort')) + "\n          "), _c('i', {
    class: _vm.showSort ? 'ti-arrow-circle-up' : 'ti-arrow-circle-down'
  })])]), _vm._v(" "), (_vm.showSort) ? _c('div', {
    staticClass: "scrollmenu scrollmenu-spaced section-top-xs"
  }, _vm._l((_vm.sorts), function(item) {
    return _c('span', {
      key: item
    }, [_c('span', {
      staticClass: "chips-group clickable",
      on: {
        "click": function($event) {
          return _vm.onSelectedSort(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClassSort(item)
    }, [_vm._v(_vm._s(_vm.isSelectedSort(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n        ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showFilters) ? _c('div', {
    staticClass: "filter-main section-top-xs"
  }, [_c('div', {
    staticClass: "articles-report__extra-filters",
    class: _vm.isMobile() ? 'flex-container-trainer-left' : 'flex-container'
  }, [_c('div', {
    staticClass: "input-group articles-report__date-wrap"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_from')) + ":")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group articles-report__date-wrap"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_to')) + ":")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group section-top-xs articles-report__auto-wrap"
  }, [(_vm.visibleCategory) ? _c('autocompleteObject', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "suggestions": _vm.categories,
      "placeholder": _vm.locale.t('label_a_category')
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.newSelectedCategory = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.visibleCategory) ? _c('div', {
    staticClass: "input clickable",
    on: {
      "click": function($event) {
        _vm.newSelectedCategory = ''
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.newSelectedCategory) + " "), _c('i', {
    staticClass: "ti-trash"
  })])]) : _vm._e()], 1), _vm._v(" "), (!_vm.visibleCategory) ? _c('div', {
    staticClass: "section-top-xs articles-report__auto-wrap"
  }, [(_vm.visibleSubCategory) ? _c('autocompleteObject', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "suggestions": _vm.selectedSubCategories,
      "placeholder": _vm.locale.t('label_a_sub_category')
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.newSelectedSubCategory = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.visibleSubCategory) ? _c('div', {
    staticClass: "input clickable",
    on: {
      "click": function($event) {
        _vm.newSelectedSubCategory = ''
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.newSelectedSubCategory) + " "), _c('i', {
    staticClass: "ti-trash"
  })])]) : _vm._e()], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.reportLoading) ? _c('section', {
    staticClass: "articles-report__loading"
  }, [_c('div', {
    staticClass: "loader"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : _vm._e(), _vm._v(" "), (_vm.hasReportData && !_vm.reportLoading && !_vm.canSeeOnlyKp()) ? _c('section', {
    staticClass: "articles-report__summary section-top"
  }, [_c('header', {
    staticClass: "articles-report__section-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_report_summary')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.selectedStatus.name) + " · EUR")])]), _vm._v(" "), _c('div', {
    staticClass: "articles-report__kpi-grid"
  }, _vm._l((_vm.summaryCards), function(card) {
    return _c('article', {
      key: card.key,
      staticClass: "articles-report__kpi",
      class: {
        'articles-report__kpi--positive': card.positive
      }
    }, [_c('div', {
      staticClass: "articles-report__kpi-title"
    }, [_vm._v(_vm._s(card.title))]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__kpi-value"
    }, [_vm._v(_vm._s(card.value))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.hasReportData && !_vm.reportLoading && !_vm.canSeeOnlyKp()) ? _c('section', {
    staticClass: "articles-report__charts section-top"
  }, [_c('article', {
    staticClass: "articles-report__chart-card"
  }, [_c('header', {
    staticClass: "articles-report__chart-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_profit')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("EUR")])]), _vm._v(" "), _c('div', {
    staticClass: "articles-report__rows"
  }, _vm._l((_vm.profitChartData), function(item) {
    return _c('div', {
      key: 'p-' + item.label,
      staticClass: "articles-report__row"
    }, [_c('div', {
      staticClass: "articles-report__label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__bar-wrap"
    }, [_c('div', {
      class: ['articles-report__bar', item.accent],
      style: ({
        width: _vm.chartWidth(item.value, _vm.maxProfitValue)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__value"
    }, [_vm._v(_vm._s(_vm.formatMoney(item.value)))])])
  }), 0)]), _vm._v(" "), _c('article', {
    staticClass: "articles-report__chart-card"
  }, [_c('header', {
    staticClass: "articles-report__chart-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_purchase_price')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("EUR")])]), _vm._v(" "), _c('div', {
    staticClass: "articles-report__rows"
  }, _vm._l((_vm.purchaseChartData), function(item) {
    return _c('div', {
      key: 'c-' + item.label,
      staticClass: "articles-report__row"
    }, [_c('div', {
      staticClass: "articles-report__label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__bar-wrap"
    }, [_c('div', {
      class: ['articles-report__bar', item.accent],
      style: ({
        width: _vm.chartWidth(item.value, _vm.maxPurchaseValue)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__value"
    }, [_vm._v(_vm._s(_vm.formatMoney(item.value)))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "articles-report__log section-top"
  }, [_c('header', {
    staticClass: "articles-report__section-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_article_log_report')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_article_log_report_hint')))])]), _vm._v(" "), (_vm.articleLogLoading) ? _c('div', {
    staticClass: "articles-report__loading"
  }, [_c('div', {
    staticClass: "loader"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : (_vm.articleLogLoaded && _vm.articleLogRows.length) ? _c('div', [_c('div', {
    staticClass: "articles-report__charts section-bottom-xs"
  }, [_c('article', {
    staticClass: "articles-report__chart-card"
  }, [_c('header', {
    staticClass: "articles-report__chart-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_post_on_kp_count')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_user')))])]), _vm._v(" "), _c('div', {
    staticClass: "articles-report__rows"
  }, _vm._l((_vm.articleLogPostChartData), function(item) {
    return _c('div', {
      key: 'al-post-' + item.key,
      staticClass: "articles-report__row"
    }, [_c('div', {
      staticClass: "articles-report__label",
      attrs: {
        "title": item.label
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__bar-wrap"
    }, [_c('div', {
      staticClass: "articles-report__bar articles-report__bar--purchase-eur",
      style: ({
        width: _vm.chartWidth(item.value, _vm.maxArticleLogPostValue)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), _c('article', {
    staticClass: "articles-report__chart-card"
  }, [_c('header', {
    staticClass: "articles-report__chart-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_selling_count')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_user')))])]), _vm._v(" "), _c('div', {
    staticClass: "articles-report__rows"
  }, _vm._l((_vm.articleLogSoldChartData), function(item) {
    return _c('div', {
      key: 'al-sold-' + item.key,
      staticClass: "articles-report__row"
    }, [_c('div', {
      staticClass: "articles-report__label",
      attrs: {
        "title": item.label
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__bar-wrap"
    }, [_c('div', {
      staticClass: "articles-report__bar articles-report__bar--profit-eur",
      style: ({
        width: _vm.chartWidth(item.value, _vm.maxArticleLogSoldValue)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), _c('article', {
    staticClass: "articles-report__chart-card"
  }, [_c('header', {
    staticClass: "articles-report__chart-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_uploaded_images_for_kp')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_user')))])]), _vm._v(" "), _c('div', {
    staticClass: "articles-report__rows"
  }, _vm._l((_vm.articleLogUploadedImagesChartData), function(item) {
    return _c('div', {
      key: 'al-img-' + item.key,
      staticClass: "articles-report__row"
    }, [_c('div', {
      staticClass: "articles-report__label",
      attrs: {
        "title": item.label
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__bar-wrap"
    }, [_c('div', {
      staticClass: "articles-report__bar articles-report__bar--purchase-eur",
      style: ({
        width: _vm.chartWidth(item.value, _vm.maxArticleLogUploadedImagesValue)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "articles-report__table-wrap"
  }, [_c('table', {
    staticClass: "table-main"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.locale.t('label_user')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_post_on_kp_count')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_selling_count')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_uploaded_images_for_kp')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.articleLogRows), function(item, idx) {
    return _c('tr', {
      key: 'alr-' + idx + '-' + item.userId
    }, [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_user')
      }
    }, [_vm._v(_vm._s(_vm.getArticleLogUserName(item)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_post_on_kp_count')
      }
    }, [_vm._v(_vm._s(item.postOnKpCount))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_selling_count')
      }
    }, [_vm._v(_vm._s(item.sellingCount))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_uploaded_images_for_kp')
      }
    }, [_vm._v(_vm._s(item.uploadedImages))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "data-title": _vm.locale.t('label_total')
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_total')))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-title": _vm.locale.t('label_post_on_kp_count')
    }
  }, [_vm._v(_vm._s(_vm.articleLogTotalPostOnKp))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-title": _vm.locale.t('label_selling_count')
    }
  }, [_vm._v(_vm._s(_vm.articleLogTotalSelling))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-title": _vm.locale.t('label_uploaded_images_for_kp')
    }
  }, [_vm._v(_vm._s(_vm.articleLogTotalUploadedImages))])])])])])]) : (_vm.articleLogLoaded && !_vm.articleLogRows.length) ? _c('div', {
    staticClass: "articles-report__empty"
  }, [_vm._v("\n        😐 " + _vm._s(_vm.locale.t('label_no_data_for_period')) + "\n      ")]) : _vm._e()]), _vm._v(" "), (!_vm.canSeeOnlyKp()) ? _c('section', {
    staticClass: "articles-report__log section-top"
  }, [_c('header', {
    staticClass: "articles-report__section-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_c_schedule_user_report')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_c_schedule_user_report_hint')))])]), _vm._v(" "), (_vm.cScheduleLoading) ? _c('div', {
    staticClass: "articles-report__loading"
  }, [_c('div', {
    staticClass: "loader"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : (_vm.cScheduleLoaded && _vm.cScheduleRows.length) ? _c('div', [_c('article', {
    staticClass: "articles-report__chart-card section-bottom-xs"
  }, [_c('header', {
    staticClass: "articles-report__chart-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_profit_eur')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_user')) + " → EUR")])]), _vm._v(" "), _c('div', {
    staticClass: "articles-report__rows"
  }, _vm._l((_vm.cScheduleProfitChartData), function(item) {
    return _c('div', {
      key: 'cs-p-' + item.key,
      staticClass: "articles-report__row"
    }, [_c('div', {
      staticClass: "articles-report__label",
      attrs: {
        "title": item.label
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__bar-wrap"
    }, [_c('div', {
      staticClass: "articles-report__bar articles-report__bar--profit-eur",
      style: ({
        width: _vm.chartWidth(item.value, _vm.maxCScheduleProfitValue)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "articles-report__value"
    }, [_vm._v(_vm._s(_vm.formatMoney(item.value)))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "articles-report__table-wrap"
  }, [_c('table', {
    staticClass: "table-main"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.locale.t('label_user')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_username')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_turnover_eur')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_turnover_rsd')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_profit_eur')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedCScheduleRows), function(item, idx) {
    return _c('tr', {
      key: 'csr-' + idx + '-' + item.userId
    }, [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_user')
      }
    }, [_vm._v(_vm._s(_vm.getCScheduleUserName(item)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_username')
      }
    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_turnover_eur')
      }
    }, [_vm._v(_vm._s(_vm.formatMoney(item.turnoverEur)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_turnover_rsd')
      }
    }, [_vm._v(_vm._s(_vm.formatMoney(item.turnoverRsd)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_profit_eur')
      }
    }, [_vm._v(_vm._s(_vm.formatMoney(item.profitEur)))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2",
      "data-title": _vm.locale.t('label_total')
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_total')))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-title": _vm.locale.t('label_turnover_eur')
    }
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.cScheduleTotalTurnoverEur)))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-title": _vm.locale.t('label_turnover_rsd')
    }
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.cScheduleTotalTurnoverRsd)))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-title": _vm.locale.t('label_profit_eur')
    }
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.cScheduleTotalProfitEur)))])])])])])]) : (_vm.cScheduleLoaded && !_vm.cScheduleRows.length) ? _c('div', {
    staticClass: "articles-report__empty"
  }, [_vm._v("\n        😐 " + _vm._s(_vm.locale.t('label_no_data_for_period')) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.reportLoaded && !_vm.hasReportData && !_vm.reportLoading) ? _c('section', {
    staticClass: "articles-report__empty section-top"
  }, [_vm._v("\n      😐 " + _vm._s(_vm.locale.t('label_no_data_for_period')) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cfc22cf6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Article/ArticlesReport.vue
// module id = 851
// module chunks = 0